import Swiper, { Navigation, Pagination } from 'swiper';

// Slider sekcji „Produkty" (Figma 142:736 i stany 66:434 / 66:435 / 66:495).
//
// `slidesPerView: 'auto'` + `centeredSlides` odtwarza makietę: kafle mają stałą
// szerokość z s-products.scss, aktywny stoi na osi okna, a sąsiedzi wychodzą
// poza kadr sekcji. Krycie skrajnych kafli robi CSS na klasach
// `swiper-slide-prev/active/next` — nie ma tu więc żadnego JS-a od wyglądu.
const slider = document.querySelector('[data-products-slider]');

if (slider) {
	const section = slider.closest('.s-products');

	new Swiper(slider, {
		modules: [Navigation, Pagination],
		slidesPerView: 'auto',
		centeredSlides: true,
		loop: true,
		spaceBetween: 0,
		// Kafel jest znacznie węższy od okna, więc bez tego jedno szybkie
		// przeciągnięcie przeskakuje po kilka produktów naraz.
		longSwipesRatio: 0.3,
		navigation: {
			prevEl: section?.querySelector('.s-products__nav--prev'),
			nextEl: section?.querySelector('.s-products__nav--next'),
		},
		pagination: {
			el: section?.querySelector('.s-products__dots'),
			clickable: true,
		},
	});
}
